<template>
  <div id="bjzc-activity-detail" class="bjzc-page-content">
    <div class="border-radius">
      <h3 class="uk-text-center@m">{{ $getLocaleValue(detail, 'title') }}</h3>
      <p class="uk-text-center@m">
        <span class="uk-margin-right">{{ $t('activity.publish_time') }}：{{ detail.createdAt.slice(0, 10) }}</span>
        <span>{{ $t('activity.view_count') }}：{{ detail.viewsCount }}</span>
      </p>

      <div v-if="detail.kind === 'news'" v-html="$getLocaleValue(detail, 'content')"></div>
      <div v-else-if="detail.kind === 'legal'" class="uk-text-center">
        <video id="video" width="960" height="540" controls :poster="$getLocaleValue(detail, 'coverUrl')">
          <source v-if="detail.videoUrl" :src="detail.videoUrl" type="video/mp4" />
        </video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  data() {
    return {
      detail: {
        title: '-',
        createdAt: ''
      }
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      this.$axios.get('articles/' + this.$route.params.id).then(res => {
        this.detail = res.data
        const r = this.$route
        this.$eventBus.$emit('setBreadcrumb', [
          { path: '/', title: '首页', title_en: 'Home' },
          {
            path: '/activity',
            title: this.$t('breadcrumb.activity', 'zh'),
            title_en: this.$t('breadcrumb.activity', 'en')
          },
          {
            path: r.fullPath,
            title: this.detail.title,
            title_en: this.detail.titleEn || this.detail.title
          }
        ])
      })
    }
  }
}
</script>

<style lang="scss">
#bjzc-activity-detail {
  & > div {
    background-color: #fff;
    padding: 2.5rem;
    padding-top: 0;
  }
}
@media (max-width: ($screen-width-m - 1)) {
  #bjzc-activity-detail > div {
    padding: 0 0 2.5rem;
  }
}
</style>
